import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import { withCustomValidation } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { AdDistribution } from '@bingads-webui-campaign/ad-distribution';

const defaultGetOptions = (initialAdDistribution, onChange) => ({
  AdDistribution: initialAdDistribution || 'BingYahooAndSearchPartners',
  campaignType: 'shopping',
  campaignSubType: undefined,
  Languages: [],
  isSPBCampaign: false,
  onChange,
});

const LegacyAdDistributionWithCustomValidation = ({
  setAdDistributionView, updateValidation, validationProps, getOptions,
}) => {
  const {
    data,
  } = validationProps || {};
  const {
    AdDistribution: adDistribution,
  } = data || {};

  const activity = useContext(ActivityContext);

  const onChange = useCallback((newData) => {
    updateValidation([], { AdDistribution: newData });

    if (activity) {
      // signal activity to parent
      activity.signal(`onLegacyAdDistributionChange - ${JSON.stringify(newData)}`);
    }
  }, [updateValidation, activity]);

  const options = useMemo(() => getOptions(adDistribution, onChange), [adDistribution, getOptions, onChange]);

  return (
    <div className="AdDistribution-section">
      <AdDistribution
        setAdDistributionView={setAdDistributionView}
        options={options}
      />
    </div>
  );
};

LegacyAdDistributionWithCustomValidation.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({}),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
  setAdDistributionView: PropTypes.func.isRequired,
  getOptions: PropTypes.func,
};

LegacyAdDistributionWithCustomValidation.defaultProps = {
  getOptions: defaultGetOptions,
};

export const ValidatedLegacyAdDistribution = withCustomValidation(LegacyAdDistributionWithCustomValidation);
